import React, { useContext } from 'react';
import { UserContext } from '../../Contexts/UserContext/UserContext';

import "./TextDisplay.css"
import { appConfig } from '../../config.js';


const theme = appConfig.theme
const custom_style = {
	backgroundColor: theme.backgroundColorLighter1,
}

// // deprecated
// export function TextDisplayBSV(props) {
// 	return (
// 		<TextDisplay background="linear-gradient(334.78deg, #726939 0%, #3d3d3d 68.54%)"
// 			backgroundLogo={Constants.IMAGES.bsv_logo}>
// 			{props.children}
// 		</TextDisplay>
// 	)
// }

// TODO add color & logo to smartcontract and load them from it ?
/**
 * 
 * @param {*} props - tokenid: force a tokenid instead of using the one from the userContext
 * @returns 
 */
export function TextDisplayToken(props) {

	let coinProps
	const userContext = useContext(UserContext)
	if (props.tokenid) {
		coinProps = userContext.get_coin_props(props.tokenid)
	} else {
		coinProps = userContext.get_selected_coin_props()
	}

	return (
		<TextDisplay background={coinProps.background_css || ""}
			backgroundLogo={coinProps.logo_banner} >
			{props.children}
		</TextDisplay>
	)
}


export function TextDisplay(props) {
	/*	props:
			- centered			to center the content
			- children			jsx as children
			- background: 		css property background to display a colored background
			- backgroundLogo:   a var of an imported image
	*/

	var content_jsx = props.children

	if (props.centered) {
		content_jsx = <center>
			{props.children}
		</center>
	}

	// remove "centered" from props to pass on
	const { centered, backgroundLogo, ...other_props } = { ...props }

	var logoName = "logo "
	if (props.backgroundLogo) {
		logoName += props.backgroundLogo.split('/').slice(-1)[0].split('\\').slice(-1)[0]
		// console.log("logoName=",logoName)
	}

	return (
		// <div className='row' style={{ width: "100%", }} {...other_props} >
		<div className='row' style={{ display: "contents", }} {...other_props} >
			<div style={{
				margin: "0 auto", maxWidth: "40em",
				wordBreak: "break-word", display: "block", padding: "0"
			}}>
				<pre className='item' style={{
					overflow: "hidden",
					background: props.background,
					wordBreak: "break-word",
					margin: "0",
					...custom_style,
				}}>
					{props.backgroundLogo ?
						<img src={props.backgroundLogo} alt={logoName} style={{
							top: "-12%",
							// right: "-5%",
							float: "right",
							right: "0%",
							// right: "calc( 95% - 40em )",
							opacity: .2,
							zIndex: -1,
							overflow: "hidden",
							position: "absolute",
							borderRadius: "12px",
							height: "min( 100%, 20em )",
						}} />
						: null}
					{content_jsx}
				</pre>
			</div>
		</div>
	)
}
